import {
  getAuth,
  FacebookAuthProvider,
  signInWithPopup,
  GoogleAuthProvider,
  fetchSignInMethodsForEmail,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  OAuthProvider,
  linkWithPopup,
  EmailAuthProvider,
  linkWithCredential,
  sendSignInLinkToEmail,
  sendEmailVerification
} from "firebase/auth";

export async function loginWithGoogle(email) {
  const auth = getAuth();
  // auth.languageCode = 'it';
  // To apply the default browser preference instead of explicitly setting it.
  // auth.useDeviceLanguage();
  const provider = new GoogleAuthProvider();
  if (email) {
    provider.setCustomParameters({
      'login_hint': email
    })
  }
  try {
    const result = await signInWithPopup(auth, provider);
    return { data: result };
  } catch (error) {
    const errorInfo = {
      code: error.code,
      message: error.message,
      email: error.customData?.email,
      credential: GoogleAuthProvider.credentialFromError(error)
    };
    return {
      error,
      errorInfo
    };
  }
}

export async function loginWithPassword(email, password) {
  const auth = getAuth();
  const methods = await fetchSignInMethodsForEmail(auth, email);
  let result = null;
  try {
    if (methods.includes('password')) {
      result = await signInWithEmailAndPassword(auth, email, password);
    } else {
      result = await createUserWithEmailAndPassword(auth, email, password);
    }

    return { data: result };
  } catch (error) {
    const errorInfo = {
      code: error.code,
      message: error.message,
      email: error.customData?.email,
      credential: { providerId: "password" }
    };
    return { error, errorInfo };
  }
}

export async function loginWithFacebook() {
  const auth = getAuth();
  const provider = new FacebookAuthProvider();
  try {
    const result = await signInWithPopup(auth, provider);
    return { data: result };
  } catch (error) {
    const errorInfo = {
      code: error.code,
      message: error.message,
      email: error.customData?.email,
      credential: FacebookAuthProvider.credentialFromError(error)
    };
    return {
      error,
      errorInfo
    };
  }
}

export async function loginWithApple(email) {
  const auth = getAuth();
  const provider = new OAuthProvider("apple.com");
  if (email) {
    provider.setCustomParameters({
      'login_hint': email
    })
  }
  try {
    const result = await signInWithPopup(auth, provider);
    return { data: result };
  } catch (error) {
    const errorInfo = {
      code: error.code,
      message: error.message,
      email: error.customData?.email,
      credential: OAuthProvider.credentialFromError(error)
    };
    return {
      error,
      errorInfo
    };
  }
}

export async function linkWithGoogle(email) {
  const provider = new GoogleAuthProvider();
  if (email) {
    provider.setCustomParameters({
      'login_hint': email
    })
  }

  const auth = getAuth();
  if (!auth.currentUser) {
    return { error: "No user currently signed in" };
  }
  try {
    const result = await linkWithPopup(auth.currentUser, provider);
    return { data: result };
  } catch (error) {
    return { error };
  }
}

export async function linkWithFacebook() {
  const provider = new FacebookAuthProvider();
  const auth = getAuth();
  if (!auth.currentUser) {
    return { error: "No user currently signed in" };
  }
  try {
    const result = await linkWithPopup(auth.currentUser, provider);
    return { data: result };
  } catch (error) {
    return { error };
  }
}

export async function linkWithApple(email) {
  const provider = new OAuthProvider("apple.com");
  const auth = getAuth();
  if (email) {
    provider.setCustomParameters({
      'login_hint': email
    })
  }
  if (!auth.currentUser) {
    return { error: "No user currently signed in" };
  }
  try {
    const result = await linkWithPopup(auth.currentUser, provider);
    return { data: result };
  } catch (error) {
    return { error };
  }
}

export async function linkWithPassword(email, password) {
  const auth = getAuth();
  const user = auth.currentUser;

  if (!user) return { error: "No user is currently signed in" };

  try {
    const credential = EmailAuthProvider.credential(email, password);
    const result = await linkWithCredential(user, credential);
    return { data: result };
  } catch (error) {
    return { error };
  }
}

export async function linkWithOAuthToken(providerId, credentialInput) {
  const auth = getAuth();
  const user = auth.currentUser;

  if (!user) {
    return { error: "No user currently signed in" };
  }

  let credential;

  if (
    typeof credentialInput === "object" &&
    "providerId" in credentialInput &&
    typeof credentialInput.signInMethod === "string"
  ) {
    credential = credentialInput;
  } else {
    const tokens = credentialInput;

    switch (providerId) {
      case "google.com": {

        credential = GoogleAuthProvider.credential(tokens.idToken, tokens.accessToken);
        break;

      }
      case "facebook.com": {
        credential = FacebookAuthProvider.credential(tokens.accessToken);
        break;
      }

      case "apple.com": {
        const appleProvider = new OAuthProvider("apple.com");
        credential = appleProvider.credential({
          idToken: tokens.idToken,
          accessToken: tokens.accessToken
        });
        break;
      }

      default: {

        return { error: "Unsupported provider" };
      }
    }
  }

  try {
    const result = await linkWithCredential(user, credential);
    return { data: result };
  } catch (error) {
    return { error };
  }
}

export async function sendVerifyEmail(user, actionCodeSettings = {
  url: 'https://fluenday.com',
  handleCodeInApp: true,
  linkDomain: 'fluenday.com'
}) {

  const auth = getAuth();
  const currentUser = user ?? auth.currentUser;
  try {
    await sendEmailVerification(currentUser, actionCodeSettings)
    return { data: true }
  } catch (error) {
    const errorInfo = {
      code: error.code,
      message: error.message
    };
    return { error, errorInfo };
  }
}